// extracted by mini-css-extract-plugin
module.exports = {"title":"title-module--title--2k7Uw","titleText":"title-module--title-text--1OgLX"};